import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Card, Grid, Typography, CardContent } from "@mui/material";

import { useGetPatientAnalyticQuery } from "app/store/dashboard/patient_analytic/api/patientAnalyticApi";
import Loading from "components/common/loading/Loading";

import PatientsChart from "./chart/PatientsChart";
import PatientAnalyticAccountFilter from "./filters/PatientAnalyticAccountFilter";
import PatientAnalyticDateFilter from "./filters/PatientAnalyticDateFilter";
import { changeFilter } from "app/store/dashboard/patient_analytic/slice/patientAnalyticSlice";
import { getFormattedDate, subtractFromDate } from "utils/date";
import { DATE_FORMAT } from "static/date";
import { showErrorToast } from "utils/toast";

const PatientAnalytic = () => {
  const dispatch = useDispatch();
  const { accountFilter, startDate, endDate } = useSelector(
    (state) => state.patientAnalytic
  );
  const {
    data: patientAnalyticData,
    isLoading: isPatientAnalyticLoading,
    isFetching,
    error,
    isError,
  } = useGetPatientAnalyticQuery(
    { account: accountFilter, startDate, endDate },
    {
      refetchOnMountOrArgChange: true,
    }
  );

  useEffect(() => {
    dispatch(
      changeFilter({
        type: "startDate",
        value: subtractFromDate(new Date(), 1, "month").format(
          DATE_FORMAT.ISO_YYYYMMDD
        ),
      })
    );

    dispatch(
      changeFilter({
        type: "endDate",
        value: getFormattedDate(new Date()),
      })
    );
  }, []);

  useEffect(() => {
    if (isError && error?.message) {
      showErrorToast(error?.message);
    }
  }, [isError]);

  return (
    <Card
      elevation={0}
      sx={{
        border: "1px solid #E0E0E0",
        borderRadius: "4px",
        height: "100%",
      }}
    >
      <CardContent>
        <Grid
          container
          flex={1}
          justifyContent="space-between"
          sx={{ marginBottom: "20px" }}
          spacing={1}
        >
          <Grid item>
            <Typography
              variant="h6"
              sx={{ fontSize: "1.125rem", fontWeight: 500 }}
            >
              Total Patients
            </Typography>
          </Grid>
          <Grid item>
            <Grid container alignItems="center" spacing={1}>
              <PatientAnalyticAccountFilter />
              <PatientAnalyticDateFilter />
            </Grid>
          </Grid>
        </Grid>

        {isPatientAnalyticLoading || isFetching ? (
          <Loading height="350px" />
        ) : (
          <Grid container flex flexDirection={"column"}>
            <PatientsChart data={patientAnalyticData} />
          </Grid>
        )}
      </CardContent>
    </Card>
  );
};

export default PatientAnalytic;
